/*
 * ============================================================
 * SAV_ERP — Smart Account Vision Enterprise Resource Planning
 * Copyright (c) 2026 Hatem Mohamed Abdalla.
 * All rights reserved.
 *
 * This file is part of a proprietary software product owned
 * solely by Hatem Mohamed Abdalla (UAE, +971 50 390 9781).
 * Copying, redistribution, modification, reverse engineering
 * or reuse in any form without prior written consent of the
 * copyright owner is strictly prohibited and will be
 * prosecuted under UAE Federal Law No. 38/2021 on Copyright
 * and applicable international treaties.
 *
 * Fingerprint: SAV-ERP-HMA-2026-#a7f3d0
 * ============================================================
 */
import "./utils/customerConsole";
import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./mobile.css";
import "./security.css";
import FullERPApp from "./FullERPApp";

const PublicApp = lazy(() => import("./public/PublicApp"));
const PUBLIC_PATH = typeof window !== "undefined" ? window.location.pathname : "";
const ERP_QUERY = typeof window !== "undefined" && /[?&]view=/.test(window.location.search || "");
// Entry separation: root "/" is the public SAV Software site; the ERP application lives under "/app".
// The ERP routes internally via a "?view=" query (keeping pathname "/"), so any ?view= is ERP too.
const isERP = PUBLIC_PATH === "/app" || PUBLIC_PATH.startsWith("/app/") || ERP_QUERY;
// Backward-compatible redirects to the new root-based public URLs.
if (typeof window !== "undefined" && !isERP) {
  if (PUBLIC_PATH.startsWith("/site")) {
    const h = (window.location.hash || "").replace(/^#/, "");
    window.location.replace(h && h !== "/" ? h : "/");
  } else if (PUBLIC_PATH === "/sav-software" || PUBLIC_PATH.startsWith("/sav-software/")) {
    window.location.replace(PUBLIC_PATH.replace(/^\/sav-software/, "") || "/");
  }
}
const isPublicSite = !isERP;

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(isPublicSite ? <Suspense fallback={null}><PublicApp /></Suspense> : <FullERPApp />);


if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sav-employee-sw.js').catch(() => null);
  });
}
